import { Button, Layout } from "antd";
import { GeneralStore } from "../stores";
import { MainSidebarItems, SidebarLogoutButton } from "../sharedComponents";
import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";

const { Sider } = Layout;

const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED = 72;

export const Sidebar = () => {
  const { sidebarCollapsed, setSidebarCollapsed } = GeneralStore();
  const width = sidebarCollapsed ? SIDEBAR_COLLAPSED : SIDEBAR_WIDTH;

  return (
    <Sider
      width={SIDEBAR_WIDTH}
      collapsedWidth={SIDEBAR_COLLAPSED}
      style={{
        flex: `0 0 ${width}px`,
        minWidth: `${width}px`,
        maxWidth: `${width}px`,
      }}
      className="spor-sidebar !h-screen !max-h-screen !min-h-screen overflow-hidden sm:sticky top-0 flex-col justify-between"
      breakpoint="lg"
      collapsible
      collapsed={sidebarCollapsed}
      trigger={null}
    >
      <div className="h-full flex flex-col justify-between">
        <div
          style={{ scrollbarWidth: "none" }}
          className="overflow-y-auto scrollbar-hide flex-1"
        >
          <MainSidebarItems />
        </div>
        <div className="spor-sidebar-footer">
          <SidebarLogoutButton />
          <Button
            size="large"
            block
            className="spor-sidebar-toggle !rounded-none !w-full flex items-center justify-center"
            type="text"
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          >
            {sidebarCollapsed ? (
              <DoubleRightOutlined size={20} />
            ) : (
              <DoubleLeftOutlined size={20} />
            )}
          </Button>
        </div>
      </div>
    </Sider>
  );
};
